import { ReturnRepository } from "@domain/repositories/ReturnRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = Client["id"];

type Output = Promise<Client>;

export class ReleaseReturnUseCase implements UseCase<Input, Output> {
  constructor(private readonly returnRepository: ReturnRepository) {}

  execute(clientId: Input) {
    return this.returnRepository.release(clientId);
  }
}
